import React, {useEffect, useState} from "react";
import {Link} from "gatsby";
import Logo from "../../assets/evo-campus.svg";
import CircleArrow from "../../assets/circle-arrow.svg";
import InputText from "../form-elements/input-text";
import GetUpdates from "../v2/get-updates";
import ProjectsList from "./projects-list";

const Header = (
  {
    hamburgerStateCallback = () => {},
    headerLayout = "full",
  }
) => {
  const [isHeaderMobileLayout, setHeaderMobileLayout] = useState(headerLayout === "mobile");
  const [isHeaderDark, setHeaderDark] = useState( false);

  const [isHamburgerActive, setHamburgerState] = useState(false);
  const [isHamburgerHover, setHamburgerHoverState] = useState(false);
  const [isDropdown1Active, setDropdown1State] = useState(false);
  const [isDropdown2Active, setDropdown2State] = useState(false);
  const [isInputMessageActive, setInputMessageState] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);
    document.body.addEventListener('click', closeDropdown );

    return () => {
      window.removeEventListener('click', closeDropdown );
      window.removeEventListener("scroll", scrollHandler);
    }
  }, [])

  useEffect(() => {
    setDropdown1State(isHamburgerActive);
    setDropdown2State(isHamburgerActive && isDropdown1Active);
    hamburgerStateCallback(isHamburgerActive);
  }, [isHamburgerActive])

  const handleHamburgerState = () => {
    if (isDropdown2Active) {
      setDropdown2State(false);
      setDropdown1State(true);
    } else {
      setHamburgerState(!isHamburgerActive);
    }
  }

  const handleDropdownHamburgerState = () => {
    setHamburgerState(!isHamburgerActive);
  }

  const handleInputFocus = () => {
    setInputMessageState(true);
  }

  const handleInputBlur = () => {
    setInputMessageState(false);
  }

  const handleEmailSubmit = () => {}

  const handleGetUpdatesDropdown1Button = () => {
    setDropdown2State(!isDropdown2Active);
  }

  const closeDropdown = (event) => {
    if (event.target.classList.contains('overlay')) {
      setHamburgerState(false);
    }
  }

  const scrollHandler = () => {
    const staticHero = document.querySelector('.static-hero');
    const simpleHero = document.querySelector('.simple-hero');
    const offset = 110;

    if (staticHero) {
      const contentWrapper = staticHero.querySelector('.static-hero__content-container');

      if ( contentWrapper.getBoundingClientRect().top - offset < 0 ) {
        setHeaderDark(true);
        setHeaderMobileLayout(true);
      } else {
        setHeaderDark(false);
        setHeaderMobileLayout(false);
      }
    }

    if (simpleHero) {
      const contentWrapper = simpleHero.querySelector('.simple-hero__content-container');

      if ( contentWrapper.getBoundingClientRect().top - offset < 0 ) {
        setHeaderDark(true);
      } else {
        setHeaderDark(false);
      }
    }
  }

  const hamburgerMouseEnterHandle = () => {
    setHamburgerHoverState(true);
  }

  const hamburgerMouseLeaveHandle = () => {
    setHamburgerHoverState(false);
  }

  return (
    <header className="header">
      <div className={`header__nav-container ${isHeaderDark ? 'header__nav-container--dark' : ''}`}>
        <div className="header__logo-container">
          <Link to={"/"} className={`header__logo ${isDropdown2Active ? 'header__logo--dark' : ''}`} aria-label="Evo">
            <Logo className="header__logo-svg" />
          </Link>
        </div>
        <div className={`header__hamburger-container ${isHeaderMobileLayout ? 'header__hamburger-container--mobile' : 'header__hamburger-container--desktop'}`}>
          <button
            className={`header__hamburger hamburger hamburger--squeeze ${isDropdown2Active ? 'hamburger--dark' : ''} ${isHamburgerActive ? 'is-active' : ''} ${isHamburgerHover ? 'is-hover' : 'is-not-hover'} `}
            type="button"
            aria-label="Menu Button"
            onClick={handleHamburgerState}
            onMouseEnter={hamburgerMouseEnterHandle}
            onMouseLeave={hamburgerMouseLeaveHandle}
          >
            <span className="hamburger-label">
              <span className="d-md-none">
                {!isHamburgerActive && (
                  <span>See Stories</span>
                )}
                {isDropdown1Active && !isDropdown2Active && (
                  <span>Close Menu</span>
                )}
                {isDropdown2Active && (
                  <span>Back To Menu</span>
                )}
              </span>
              <span className="d-none d-md-block">View all stories</span>
            </span>
            {isDropdown2Active ? (
              <>
                <CircleArrow className="hamburger--icon d-md-none" />
                <span className="hamburger-box d-none d-md-block">
                  <span className="hamburger-inner"></span>
                </span>
              </>
            ) : (
              <span className="hamburger-box">
                <span className="hamburger-inner"></span>
              </span>
            )}
          </button>
        </div>
        <div className={`header__get-updates-container ${isHeaderMobileLayout ? 'header__get-updates-container--mobile' : 'header__get-updates-container--full'}`}>
          <div className="header__input-wrapper">
            <div className="input-group">
              <div className="input-group__input-wrapper">
                <InputText
                  className="input-group__input"
                  placeholder="Enter email for updates"
                  ariaLabel="Email"
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                />
              </div>
              <div className={`input-group__message-wrapper ${isInputMessageActive ? 'active' : ''}`}>
                <span className="input-group__message">Clicking submit you agree to evo’s privacy policy</span>
              </div>
            </div>
          </div>
          <div className="header__submit-wrapper">
            <button
              type="submit"
              className="button button--primary"
              onClick={handleEmailSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      {/* Dropdown 1 */}
      <div className={`header__dropdown-container header__dropdown-container--container-1 header__dropdown-container--dark ${isDropdown1Active ? 'active' : ''}`}>
        <div className="header__dropdown-content-wrapper">
          <div className={`header__dropdown-hamburger-wrapper ${isHamburgerActive ? 'header__dropdown-hamburger-wrapper--active' : ''}`}>
            <button
              className={`header__hamburger hamburger hamburger--squeeze ${isHamburgerActive ? 'is-active' : ''}`}
              type="button"
              aria-label="Menu Button"
              onClick={handleDropdownHamburgerState}
            >
              <span className="hamburger-label">
                <span >Close Menu</span>
              </span>
              <span className="hamburger-box">
                <span className="hamburger-inner"></span>
              </span>
            </button>
          </div>
          <div className="header__dropdown-content">
            <ProjectsList />
          </div>
          <div className={`header__dropdown-get-updates-button-wrapper ${isDropdown2Active ? 'header__dropdown-get-updates-button-wrapper--hidden' : ''}`}>
            <button
              type="submit"
              className="button button--primary"
              onClick={handleGetUpdatesDropdown1Button}
            >
              Get Updates
            </button>
          </div>
        </div>
      </div>

      {/* Dropdown 2 */}
      <div className={`header__dropdown-container header__dropdown-container--container-2 header__dropdown-container--light ${isDropdown2Active ? 'active' : ''}`}>
        <div className="header__dropdown-content-wrapper">
          <div className="header__dropdown-get-updates-wrapper">
            <GetUpdates
              layout="mobile"
              preTitle="Opening"
              title="Soon"
              description="Join our emal list to receive updates on your progress."
            />
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
